export const getBundleVersion = () => {
  const version = __APP_VERSION__;
  window.__APP_VERSION__ = version;

  if (!version) {
    // eslint-disable-next-line no-console
    import.meta.env.PROD && console.info("No app version found!");
    return;
  }

  return version;
};

export const getAppName = () => {
  const appName = __APP_NAME__;

  if (!appName) {
    throw new Error("No app name found!");
  }

  return appName;
};
